module.exports = __webpack_public_path__ + "static/voice4-a0541ee786bfccde11f7c81843af30f5.webp";